import { DateField } from '@twiceme-technology/api-types/v1/types'
import { DateTime, DateTimeFormatOptions } from 'luxon'

const normalizeToDateTime = (date: string | Date | DateTime) => {
  if (date instanceof DateTime) {
    return date
  }
  if (typeof date === 'string') {
    return DateTime.fromISO(date)
  }
  return DateTime.fromJSDate(date)
}

export const getLocaleFormattedDate = (
  date: DateTime | DateField,
  options?: DateTimeFormatOptions,
): string => {
  const dateTimeDate = normalizeToDateTime(date)


  return dateTimeDate
    .setLocale(navigator.language)
    .toLocaleString(
      options ?? { year: 'numeric', month: 'numeric', day: 'numeric' }
    )
}
